module.exports = __webpack_public_path__ + "static/media/globe_big.6b557900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/globe_big.png
// module id = ./src/assets/media/icons/globe_big.png
// module chunks = 16